import React from 'react'
import styles from '../styles/work.css'
import Project from './Project'
import { motion } from 'framer-motion'
import covidnews from "../images/covidnews.png"
import recipeguide from "../images/recipeguide.jpg"
import tvshow from "../images/Tv_Show.png"

const Work = (props) => {

  return (
    <div className='work'>
        <motion.h2 
        initial={{opacity: 0, y: 50}}
        whileInView={{opacity: 1, y:0}}
        transition={{type: "just",duration: 0.5}}
        id='work'>My Recent Work</motion.h2>
        <motion.p
        initial={{opacity: 0, y: 50}}
        whileInView={{opacity: 1, y:0}}
        transition={{type: "just",duration: 0.5}}
        className="caption title">Here are a few past design projects I've worked on. Want to see more? <span><a className='caption email' href="mailto:lexypaul14@gmail.com">Email me.</a></span></motion.p>
        <div className="projects">
          <Project github={true} img={covidnews} title={"Covid News"} link={"https://github.com/lexypaul13/Covid-News"}/>
          <Project github={true} img={recipeguide} title={"Recipe Guide"} link={"https://github.com/lexypaul13/RecipeGuide"}/>
          <Project github={true} img={tvshow} title={"Trending Tv Shows"} link={"https://github.com/lexypaul13/Trending-Tv-Shows"}/>
        </div>
    </div>
  )
}
 
export default Work